// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { StocksQuoteModule } from './app.module';
bootstrapAppModule(StocksQuoteModule);
